// v6 F42k — Auto-select on first focus voor automatisch gegenereerde namen.
// Wanneer een gebruiker op een naamveld klikt dat nog de standaard auto-
// gegenereerde naam bevat (bv. "Woning", "Gevel 1", "Dakoversteek 2"), wordt
// de volledige inhoud automatisch geselecteerd zodat één toets alles overschrijft.
// Na een handmatige hernoeming (naam wijkt af van het patroon) gedraagt het
// veld zich normaal (cursor op klikpositie, geen auto-select).

const AUTO_NAME_PATTERNS = [
  // Interior room-types (v6 F42k Fase 3 + legacy ROOM_PRESETS)
  /^(Woonruimte|Binnenruimte|Kantoor|Magazijn|Industri(ë|e)le ruimte|Publieke ruimte|Living|Keuken|Eetkamer|Hal ?\/? ?Inkom|Traphal|Slaapkamer|Badkamer|Toilet|Berging|Bureau|Garage|Zolder|Kamer|Nieuwe kamer|Algemeen)( \d+)?$/i,
  // Exterior zone-presets (v6 F42k Fase 3)
  /^(Woning|Chalet|Bijgebouw|Bedrijfsgebouw|Tuinmuur|Voorgevel|Achtergevel|Linkergevel|Rechtergevel|Buitenelementen|Werkzone|Zone|Trap|Trapwerken|Binnenschrijnwerk|Buitenschrijnwerk|Schrijnwerk|Ander buitenelement)( \d+)?$/i,
  // Facade surfaces (auto: "Gevelvlak 1", "Gevel 2", eventueel met puntgevel-suffix)
  /^Gevel(vlak)? \d+( — .+)?$/i,
  // Extra elements (auto: "Dakoversteek", "Boeiboord 2")
  /^(Dakoversteek|Boeiboord|Kroonlijst|Raamlijst|Dorpel|Aanvullend element|Aanvullend buitenelement)( \d+)?$/i,
  // v6 F42k P2 — Joinery-object kinds (Raam / Deur / Poort / Luik / Rolluik /
  // Meubels / Kasten / MDF / Tablet / Vrij object). Match OBJECT_KIND_LABEL
  // waardes uit JoineryBlock.jsx.
  /^(Raam|Schuifraam|Deur|Buitendeur|Binnendeur|Schuifdeur|Kastdeur|Binnenraam|Garagepoort|Poort ?\/? ?hek|Luik|Rolluikkast|Rolluiklamellen|Vrij object|Keukenmeubel(front)?|Badmeubel(front)?|Radiatorkast|Open kast|Gesloten kast|Meubel|Keukentablet|MDF-paneel|Kroonlijst ?\/? ?kornis)( \d+)?$/i,
];

/**
 * True wanneer de waarde een van de bekende auto-gegenereerde patronen is,
 * of leeg is. Wanneer true → het naamveld wordt bij focus volledig geselecteerd.
 */
export function isAutoGeneratedName(value) {
  if (value === null || value === undefined) return true;
  const s = String(value).trim();
  if (s.length === 0) return true;
  return AUTO_NAME_PATTERNS.some((re) => re.test(s));
}

/**
 * Focus handler die de inhoud selecteert als de naam nog automatisch is.
 * Werkt zowel op desktop (klik) als mobiel (tap → focus event).
 * setTimeout(0) is nodig omdat sommige browsers de selectie annuleren
 * direct na de focus-callback (met name iOS Safari).
 */
export function autoSelectOnFocus(e) {
  const el = e.target;
  if (!el || typeof el.select !== "function") return;
  const val = el.value;
  if (!isAutoGeneratedName(val)) return;
  // Vermijd dubbele select bij herhaalde focus binnen zelfde tick
  setTimeout(() => {
    try { el.select(); } catch (_) { /* noop */ }
  }, 0);
}
